<template>
  <div class="home">
    <swiper class="swiper" :options="swiperOption">
      <img
        class="home-swiper-img-word"
        src="~@/assets/images/home-banner-4.png"
      />
      <swiper-slide>
        <img class="home-swiper-img" src="~@/assets/images/home-banner-1.jpg" />
      </swiper-slide>
      <swiper-slide>
        <img class="home-swiper-img" src="~@/assets/images/home-banner-2.jpg" />
      </swiper-slide>
      <swiper-slide>
        <img class="home-swiper-img" src="~@/assets/images/home-banner-3.jpg" />
      </swiper-slide>
    </swiper>
    <swiper class="swiper" :options="swiperOption">
      <div class="home-swiper-img-word">
        <div class="home-swiper-img-word-content">
          惜天地福緣，種藝術福田
          <br />神恩浩蕩，藝術無疆 <br />義薄雲天昭日月，藝傳薪火立千秋
          <br />公平正直入門不拜無妨，詭詐奸刁到廟傾城何益
        </div>
      </div>
      <swiper-slide>
        <img
          class="home-swiper-img-mobile"
          src="~@/assets/images/home-banner-1-mobile.png"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="home-swiper-img-mobile"
          src="~@/assets/images/home-banner-2-mobile.png"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="home-swiper-img-mobile"
          src="~@/assets/images/home-banner-3-mobile.png"
        />
      </swiper-slide>
    </swiper>
    <div class="home-banner">
      <img src="~@/assets/images/home-img-art-history.jpg" />
    </div>
    <div class="home-img-group">
      <div>
        <img src="~@/assets/images/home-img-people-1.jpg" />
      </div>
      <div class="home-hover-dark">
        <router-link :to="{ path: '/art', query: { page: '3' } }">
          <img src="~@/assets/images/home-img-people-2.jpg" />
          <div class="home-img-group-info">
            <div>林洸沂</div>
            <div></div>
            <div>See More</div>
          </div>
        </router-link>
      </div>
      <div class="home-hover-dark">
        <router-link :to="{ path: '/art', query: { page: '2' } }">
          <img src="~@/assets/images/home-img-people-3.jpg" />
          <div class="home-img-group-info">
            <div>陳正雄</div>
            <div></div>
            <div>See More</div>
          </div>
        </router-link>
      </div>
      <div>
        <img src="~@/assets/images/home-img-people-4.jpg" />
      </div>
    </div>
    <div class="home-banner">
      <img src="~@/assets/images/home-img-local-travel.jpg" />
    </div>
    <div class="home-img-group">
      <div class="home-hover-dark">
        <router-link
          :to="{ path: '/life', query: { page: '4', name: 'street' } }"
        >
          <img src="~@/assets/images/home-img-travel-1.jpg" />
          <div class="home-img-group-info">
            <div>崎頂老街</div>
            <div></div>
            <div>See More</div>
          </div>
        </router-link>
      </div>
      <div class="home-hover-dark">
        <router-link
          :to="{
            path: '/life',
            query: { page: '4', name: 'story' },
          }"
        >
          <img src="~@/assets/images/home-img-travel-2.jpg" />
          <div class="home-img-group-info">
            <div>竹炭故事館</div>
            <div></div>
            <div>See More</div>
          </div>
        </router-link>
      </div>
      <div class="home-hover-dark">
        <router-link
          :to="{ path: '/life', query: { page: '4', name: 'park' } }"
        >
          <img src="~@/assets/images/home-img-travel-3.jpg" />
          <div class="home-img-group-info">
            <div>虎形山公園</div>
            <div></div>
            <div>See More</div>
          </div>
        </router-link>
      </div>
      <div class="home-hover-dark">
        <router-link
          :to="{ path: '/life', query: { page: '4', name: 'farm' } }"
        >
          <img src="~@/assets/images/home-img-travel-4.jpg" />
          <div class="home-img-group-info">
            <div>牛埔農塘</div>
            <div></div>
            <div>See More</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        effect: 'fade',
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      },
    };
  },
};
</script>

<style scoped>
.home {
  font-size: 72px;
  font-weight: normal;
}
.home-swiper-img {
  width: 100%;
}
.home-swiper-img-word {
  position: absolute;
  width: 30%;
  z-index: 1;
  left: 0;
  top: 0;
}
.home-img-group {
  width: 100%;
  position: relative;
}
.home-img-group > div {
  width: 25%;
  display: inline-block;
  position: relative;
}
.home-hover-dark:hover {
  filter: brightness(0.8);
}
.home-img-group img {
  width: 100%;
}
.home-banner {
  width: 35%;
  margin: auto;
}
.home-banner > img {
  width: 100%;
  margin: auto;
}
.home-img-group-info {
  position: absolute;
  top: calc(50% - 36px);
  width: 100%;
  text-align: center;
  color: #ffffff;
  font-size: 24px;
}
.home-img-group-info > div:nth-child(2) {
  width: 80%;
  border-top: 1px solid;
  border-color: #ffffff;
  margin-left: 10%;
}
.home-swiper-img-mobile {
  display: none;
}

@media (max-width: 767px) {
  .home-banner {
    width: 100%;
  }
  .home-img-group-info {
    top: calc(50% - 10px);
    font-size: 12px;
  }
  .home-img-group > div {
    width: calc(100% - 70px);
    margin: 0px 35px 0px 35px;
  }
  .home-img-group-info > div:nth-child(1) {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .home-img-group-info > div:nth-child(3) {
    margin-top: 10px;
  }
  .home-swiper-img {
    display: none;
  }
  .home-swiper-img-mobile {
    display: block;
    width: 100%;
    height: 258px;
  }
  .swiper {
    margin-top: 10px;
  }
  .home-swiper-img-word {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    top: 154px;
    bottom: 0px;
  }
  .home-swiper-img-word-content {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    width: calc(100% - 70px);
    margin: 20px 35px 20px 35px;
  }
}
</style>
